import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import NoDataContainer from '../../../../../../components/NoDataContainer';
import TableGrid from '../../../../../../components/TableGrid';
import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { TableData, transformMatrixData } from './matrixDataTable.utils';

export interface Props {
  data?: any[];
  title: string;
  translationsScope: string;
  tableFields: string[];
  showCurrency?: boolean;
  ccy?: BackportingEnums.CcyEnum;
  consolidation?: boolean;
}

const MatrixDataTable: React.FC<Props> = ({
  data,
  title,
  tableFields,
  translationsScope,
  showCurrency,
  ccy,
  consolidation = undefined,
}) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState<TableData | null>(null);
  const currenciesOfAccounts = (data || []).map((d) => d?.currencyOfAccounts);
  const currenciesOfAccountsText = Array.from(new Set(currenciesOfAccounts)).join(',');

  useEffect(() => {
    setTableData(transformMatrixData({ data, tableFields, translationsScope, t }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // we need a unique key that represents columns structure, so if columns change at runtime we should remount
  const tableDataColsKey = tableData?.columns.map((c) => c.field).join('');
  return (
    <div key={tableDataColsKey}>
      <ContentBlock
        title={t(`${translationsScope}:${title}`)}
        showCurrency={showCurrency}
        ccy={ccy}
        consolidation={consolidation}
        currenciesOfAccounts={currenciesOfAccountsText}
      >
        {tableData && tableData.rows?.length ? (
          <TableGrid
            columns={tableData.columns}
            originalProps={{
              rowData: tableData.rows,
              rowModelType: 'clientSide',
              domLayout: 'autoHeight',
              defaultColDef: {
                menuTabs: [],
              },
            }}
          />
        ) : (
          <NoDataContainer />
        )}
      </ContentBlock>
    </div>
  );
};

export default MatrixDataTable;
